import * as React from "react";
import { Provider } from "react-redux";
import Favicon = require("react-favicon");

import {AppRoutes} from "./routes";
import {store} from "./reducers";

import "./styles/index.less";
import "antd/dist/antd.less";

export const App: React.SFC<{}> = () => (
  <Provider store={store}>
    <div>
      <Favicon url={require("./img/favicon.png")} />
      <AppRoutes />
    </div>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/app.tsx